import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import PlanBuilderProgressDetail from '../../../components/Admin/PlanBuilder/PlanBuilderProgressDetail';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const PlanBuilderProgressDetailContainer = (props) => (
  <ApolloProvider client={client}>
    <PlanBuilderProgressDetail {...props} />
  </ApolloProvider>
);

export default PlanBuilderProgressDetailContainer;



